import { render, staticRenderFns } from "./NoResourcePage.vue?vue&type=template&id=d2127a50&scoped=true"
import script from "./NoResourcePage.vue?vue&type=script&lang=js"
export * from "./NoResourcePage.vue?vue&type=script&lang=js"
import style0 from "./NoResourcePage.vue?vue&type=style&index=0&id=d2127a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2127a50",
  null
  
)

export default component.exports